/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Related_Note_LinkInputs */

const vi_stocktake_related_note_link = /** @type {(inputs: Stocktake_Related_Note_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu kiểm nguồn`)
};

/**

* @param {Stocktake_Related_Note_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_related_note_link = /** @type {((inputs?: Stocktake_Related_Note_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Related_Note_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_related_note_link(inputs)
});